import { configureStore } from '@reduxjs/toolkit';
import submissionsReducer from './submissionsSlice';

export const store = configureStore({
  reducer: {
    submissions: submissionsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['submissions/setSubmissions', 'submissions/addSubmission'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['submissions.lastFetched'],
      },
    }),
});

export default store;
